import React from 'react';

export default function Home() {
  return (
    <div>Home</div>
  );
}



// WEBPACK FOOTER //
// src/base/containers/home.js